import {HttpHeaders, HttpParams, HttpClient} from "@angular/common/http";

export class FuncionesExterno {
  static getDataUser(token:string, http: HttpClient): Promise<userResponse | null>
  {
    let url = "https://graph.microsoft.com/v1.0/me?$select=id,userPrincipalName";

    const httpOptions =
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }),
        params: new HttpParams({})
      }

    return new Promise<userResponse | null>((resolve, reject) => {
      http.get(url, httpOptions)
        .subscribe({
          next: (response: any) => {
            var user: userResponse = JSON.parse(JSON.stringify(response));
            resolve(user);
          },
          error: (err) => {
            alert("Error al obtener datos del usuario");
            reject(err);
          }
        });
    });
  }

  static logout():void
  {
    localStorage.removeItem("accessToken");

  }

  static getToken():string{return localStorage.getItem("accessToken")!.toString();}

  static getFullDataUser(token:string, http: HttpClient): Promise<FullDataUser | null>
  {
    let url = "https://graph.microsoft.com/v1.0/me";

    const httpOptions =
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }),
        params: new HttpParams({})
      }

    return new Promise<FullDataUser | null>((resolve, reject) => 
    {
      http.get(url, httpOptions)
        .subscribe({
          next: (response: any) => 
          {resolve(response);},
          error: (err) => {
            alert("Error al obtener datos del usuario");
            reject(err);
          }
        });
    });
  }
}

interface userResponse {
  id: string;
  userPrincipalName: string;
}
interface FullDataUser
{
  displayName : string;
  givenName : string;  
  jobTitle : string;  
  mobilePhone : string;
  userPrincipalName : string;
  officeLocation : string;
  mail : string;
}